import "firebase/auth";
import "firebase/firestore";
import firebase from 'firebase/app'
// import * as firebaseui from "firebaseui"

import { mapState, mapActions } from "vuex";
import { commonApi,common } from "@/common/index";
export default {
  data(){
    return{
      loading:false,
      // FirebaseTypeKey: '1cric-FirebaseType',
      // firebaseConfig: {
      //   apiKey: "AIzaSyA8ZV7khtw06xjwzyJurc9nS0B8Hv96gVs",
      //   authDomain: "icric-45e8a.firebaseapp.com",
      //   databaseURL: "https://icric-45e8a-default-rtdb.firebaseio.com",
      //   projectId: "icric-45e8a",
      //   storageBucket: "icric-45e8a.appspot.com",
      //   messagingSenderId: "1071038051339",
      //   appId: "1:1071038051339:web:1a791a807127affe4a830e",
      //   measurementId: "G-VK6MWE701Z"
      // }
    }
  },
  methods: {
    ...mapActions(["checkLogin", "Login","getFirstInfo"]),
    // 第三方谷歌登录
    FirebaseLogin(){
      let provider = new firebase.auth.GoogleAuthProvider()
      firebase.auth().languageCode = this.$Cookies.get('lang')
      firebase.auth().signInWithRedirect(provider)
      this.loading = true
    },
    FirebaseSignOut() { // 退出登录
      firebase.auth().signOut().then(function() {
        firebase.clearPersistence() // 清除firebase缓存
      }).catch(function(error) {});
    },
    FirebaseInte() { // 初始化
      if (!firebase.apps.length) {
        firebase.initializeApp(this.firebaseConfig);
      }
    },
    getFirebaseRedirectResult() { // 获取登录信息
      if (!firebase.apps.length) return
      firebase.auth().getRedirectResult().then((result) => {
        if (result.user) { 
          this.loading = true 
          this.getUUID(result.user.uid)
        }
        if (result.user === undefined && result.message){
          this.$notify({ message:result.message, type:'warn',});
        }
      }).catch((error) => {
        // var errorCode = error.code;
        // var errorMessage = error.message;
        if (error.message) this.$notify({ message:error.message, type:'warn',});
        // var email = error.email;
        // var credential = error.credential;
      });
    },
    getUUID(uid) {
      const params = { uid,authType:0 }
      params.agentCode = this.$Cookies.get('agentCode') || ''
      this.$api.post(this.$urls.USER.THIRAUTHLOGIN, params, (resp) => {
        if(resp.data.code == 200){
          let uuid = resp.data.data.uuid
          this.$Cookies.set('UUID', uuid)
          common.logedUserInfo();
          this.checkLogin()
          this.loading = false
        }
      }),(err =>{ this.loading = false })
    },
  },
  created() {
    // this.FirebaseInte()
    // this.getFirebaseRedirectResult()
  },
};




// WEBPACK FOOTER //
// ./src/common/mixins/firebase.js